import { useEffect, useState } from 'react';
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { getMasterCount } from '../../../../core/_requests';
//import {WarehouseListFilter} from './WarehouseListFilter'
import { confirmAlert } from 'react-confirm-alert';
// import {OutletCustomerUpload} from '../../outlet-customer-upload/OutletCustomerUpload'
import { DealerUpload } from '../../dealer-upload/DealerUpload';

const ListToolbar = () => {
  const [masterCount, setMasterCount] = useState({ "total": 0, "active": 0, "inactive": 0 });
  const { setItemIdForUpdate } = useListView()
  const openAddMyModal = () => {
    setItemIdForUpdate(null)
  }
  useEffect(() => {
    //MenuComponent.reinitialization()

    getMasterCount('cor_dealer_m').then((result) => {
      if (result.error === false) {
        setMasterCount(result.data)

      } else {
        setMasterCount({ "total": 0, "active": 0, "inactive": 0 })
      }
    })

  }, [])

  ////////////////

  const uploadConfirm = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui bg-light'>
            <div className='gy-2 bg-primary  px-4 py-2'>
              <span className="text-light fw-bold">Upload</span>
            </div>
            <div className="px-4 py-1">
              <div className="px-4 py-8">
                <p>Select excel file to upload data?</p>
              </div>
              <div className="px-4 py-1">
                <DealerUpload close={()=>onClose ()} />
              </div>
            </div>
            <div className=" py-3 "><hr></hr>
              <div className="px-8 pb-9">
                <button className='btn btn-danger' style={{float:"right"}} onClick={onClose}>Cancel</button>
              </div>
            </div>

          </div>
        );
      }
    });

  }
  const handleDownload = () => {
    const fileUrl = process.env.PUBLIC_URL + '/sample-file/dealerUpload.xlsx'; // Path to the sample Excel file

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'dealerUpload.xlsx'; // Set the filename for the downloaded file

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <div>
        <label className="text-light fw-semibold fs-6 mx-10 bg-warning px-2 rounded">Total {masterCount.total} </label>
        <label className="text-light fw-semibold fs-6 mx-10 bg-success px-2 rounded"> Active {masterCount.active}  </label>
        <label className="text-light fw-semibold fs-6 mx-10 bg-danger px-2 rounded"> Inactive {masterCount.inactive}</label>
      </div>
      {/*<WarehouseListFilter />*/}
      {/* begin::Sample */}
      <button type='button' className='btn btn-light-primary me-3' onClick={handleDownload}>
        <KTSVG path='/media/icons/duotune/files/fil021.svg' className='svg-icon-2' />
        Sample
      </button>
      {/* end::Sample */}
      {/* begin::Upload */}
      <button type='button' className='btn btn-light-primary me-3' onClick={uploadConfirm}>
        <KTSVG path='/media/icons/duotune/files/fil022.svg' className='svg-icon-2' />
        Upload Excel
      </button>
      {/* end::Upload */}


      {/* begin::Add user */}
      <button type='button' className='btn btn-primary' onClick={openAddMyModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add Dealer
      </button>
      {/* end::Add user */}
    </div>
  )
}

export { ListToolbar }
